import { BlipApi } from 'api/BlipApi';
import { applicationDomain } from 'shared/Domains';
import { getAppSettings } from '../utils/appSettings';

const NOT_CONFIGURED_REASON = 'notConfigured';

export class AgentPlanService {
  static async isAgentPlanActive(tenantId: string): Promise<boolean> {
    try {
      const response = await BlipApi.sendCommand({
        method: 'get',
        uri: `/agent-plan/${tenantId}/active`,
        to: applicationDomain.aiPlatform,
      });

      if (response?.response?.reason === NOT_CONFIGURED_REASON) {
        const settings = await getAppSettings();
        return settings.AGENT_PLAN_NOT_CONFIGURED_KNOWLEDGE_BASE_ACCESS;
      }

      return response?.response?.hasActivePaidPlan === true || response?.response?.isTrial === true;
    } catch {
      return false;
    }
  }
}
